import React, { useContext, useState, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { useLocation, Link } from 'react-router-dom';
import findUrl from '../../../../utils/findUrl';
import categoryUrl from '../../../../utils/categoryUrl';
import restApi from '../../../../lib/restApi';
import { Context } from '../../../../context/AppContext';
import { POPULAR_INDUSTRIES } from '../../../../constants';
import HorizontalScroll from '../../../HorizontalScroll';

import './styles.css';
import NextLink from '../../../NextLink';

const PopularIndustriesList = ({
  locationSlug,
  data = POPULAR_INDUSTRIES,
  categoryPageLink,
  limit = 7,
  arrows,
}) => {
  const {
    media: { desktop, tablet },
  } = useContext(Context);
  const [industries, setIndustries] = useState([]);
  const { pathname } = useLocation();
  const listviews = {
    '/qld/gold-coast': {
      params: [
        {
          name: 'Removalists',
          keyword: 'Removalists',
          suburb: 'Gold Coast',
          state: 'QLD',
        },
        {
          name: 'Plumbers',
          keyword: 'Plumbers',
          suburb: 'Gold Coast',
          state: 'QLD',
        },
      ],
      useBreadcrumbs: true,
      breadcrumbs: [
        {
          url_slug: 'qld',
          breadcrumb: 'QLD',
        },
        {
          url_slug: 'gold-coast',
          breadcrumb: 'Gold Coast',
        },
      ],
    },
    '/nsw/hunter/newcastle': {
      useBreadcrumbs: true,
      params: [
        {
          name: 'Removalists',
          keyword: 'Removalists',
          suburb: 'Newcastle',
          state: 'NSW',
        },
      ],
      breadcrumbs: [
        {
          url_slug: 'nsw',
          breadcrumb: 'NSW',
        },
        {
          url_slug: 'newcastle',
          breadcrumb: 'Newcastle',
        },
      ],
    },
  };

  const getListviewCount = async (listview, list) => {
    const results = await listview.params.reduce(
      async (agg, { name, ...params }) => {
        const sum = await agg;
        const res = await restApi('List', {
          params: {
            size: 1,
            ...params,
          },
        });
        const { links } = res || {};
        const { meta } = links || {};
        const { search_total: total = '' } = meta || {};

        return [
          {
            ...listview,
            name,
            count: total,
          },
          ...sum,
        ];
      },
      [...list]
    );
    setIndustries(results);
  };

  const hasIcons = useMemo(() => data.filter(({ icon }) => icon), [data]);

  useEffect(() => {
    if (!hasIcons.length && listviews[pathname]) {
      getListviewCount(listviews[pathname], data);
    }
  }, []);

  if (!hasIcons.length && listviews[pathname] && !industries) return '';

  return desktop || tablet ? (
    <div className="Landing__PopularIndustriesList__list Landing__PopularIndustriesList__list--scroll">
      <HorizontalScroll
        className="Landing__PopularIndustriesList__scroll"
        arrows={arrows}
        data={[...(industries || []), ...(data || [])]
          .slice(0, limit)
          .map(
            (
              {
                name,
                category,
                subText,
                icon,
                count,
                breadcrumbs,
                slug,
                useBreadcrumbs,
              },
              index
            ) => (
              <a
                key={`${name}${index}`}
                data-category={name}
                className={classNames('Landing__PopularIndustriesList__item', {
                  'Landing__PopularIndustriesList__item--hasCount': !icon,
                })}
                href={
                  categoryPageLink
                    ? categoryUrl(slug || name || category)
                    : findUrl({
                      keyword: slug || name || category,
                      suburb_url: !useBreadcrumbs ? locationSlug : '',
                      breadcrumbs,
                    })
                }
              >
                {icon && <img src={icon} alt={name || category} />}{' '}
                {name || category}{' '}
                {subText && (
                  <span className="Landing__PopularIndustriesList__subText">
                    {subText}
                  </span>
                )}
                {!categoryPageLink && count && (
                  <span className="Landing__PopularIndustriesList__count">
                    ({count})
                  </span>
                )}
              </a>
            )
          )}
      />
    </div>
  ) : (
    <div className="Landing__PopularIndustriesList__list Landing__PopularIndustriesList__list--wrap">
      {(data || industries)
        .slice(0, limit)
        .map(
          (
            {
              name,
              category,
              subText,
              icon,
              count,
              breadcrumbs,
              slug,
              useBreadcrumbs,
            },
            index
          ) => (
            <NextLink
              key={`${name}${index}`}
              data-category={name}
              className={classNames('Landing__PopularIndustriesList__item', {
                'Landing__PopularIndustriesList__item--hasCount': !icon,
              })}
              to={
                categoryPageLink
                  ? categoryUrl(slug || name || category)
                  : findUrl({
                    keyword: slug || name || category,
                    suburb_url: !useBreadcrumbs ? locationSlug : '',
                    breadcrumbs,
                  })
              }
            >
              {icon && <img src={icon} alt={name || category} />}
              {name || category}{' '}
              {subText && (
                <span className="Landing__PopularIndustriesList__subText">
                  {subText}
                </span>
              )}
              {!categoryPageLink && count && (
                <span className="Landing__PopularIndustriesList__count">
                  ({count})
                </span>
              )}
            </NextLink>
          )
        )}
    </div>
  );
};

export default PopularIndustriesList;
